import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { MainLanguageContext } from '../context/MainLanguageContext';
import useGet from '../customHooks/useGet';
import useDelete from '../customHooks/useDelete';

const PromoCodeRow = ({ item, onDeleted, basePath }) => {
  const [deletion, deletePromoCode] = useDelete();

  useEffect(() => {
    if (deletion.data) {
      toast.success(deletion.data.message || 'Promo code deleted.');
      onDeleted(item.id);
    }
    if (deletion.error) toast.error(deletion.error?.response?.data?.message || 'Unable to delete promo code.');
  }, [deletion.data, deletion.error]);

  const confirmDelete = () => {
    swal({
      title: 'Delete promo code?',
      text: 'This promo code will be deleted.',
      buttons: true,
      icon: 'warning',
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) deletePromoCode(`promo_codes/delete/${item.id}`);
    });
  };

  return (
    <div className="my-2 flex items-center justify-between gap-4 rounded-2xl border border-[#D4DEF1] bg-white p-4">
      <div className="flex min-w-0 flex-1 items-center justify-between gap-4">
        <div className="min-w-0">
          <div className="truncate font-MluvkaBold">{item.code_title || item.code || `Promo code #${item.id}`}</div>
          <div className="mt-1 text-sm text-[#7D8CA7]">{item.code} · {item.code_type} {item.code_value}</div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <Link to={`${basePath}/view/${item.id}`} className="rounded-full border border-[#D4DEF1] px-4 py-2 text-sm text-[#52627A] transition hover:bg-[#EFF4FD]">View</Link>
          <Link to={`${basePath}/edit/${item.id}`} className="rounded-full bg-primary px-4 py-2 text-sm text-white transition hover:brightness-95">Edit</Link>
        </div>
      </div>
      {/* <button type="button" disabled={deletion.isLoading} onClick={confirmDelete} className="shrink-0 rounded-full bg-[#FFCEDA] px-4 py-2 text-sm text-[#A41139] disabled:opacity-50">
        {deletion.isLoading ? 'Deleting…' : 'Delete'}
      </button> */}
    </div>
  );
};

const UnifiedPromoCodes = () => {
  const { mainLanguage } = useContext(MainLanguageContext);
  const basePath = '/promo';
  const title = 'Promo Code';
  const [response, getCodes] = useGet();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTitle, setSearchTitle] = useState('');

  const loadPage = (nextPage, search = searchTitle) => {
    setPage(nextPage);
    getCodes(`promo_codes/list/${mainLanguage}/10?page=${nextPage}&search=${encodeURIComponent(search.trim())}`);
  };

  useEffect(() => {
    if (!mainLanguage) return;
    const timer = setTimeout(() => {
      setPage(1);
      getCodes(`promo_codes/list/${mainLanguage}/10?page=1&search=${encodeURIComponent(searchTitle.trim())}`);
    }, 300);
    return () => clearTimeout(timer);
  }, [mainLanguage, searchTitle]);

  useEffect(() => {
    const result = response.data?.data;
    setItems(Array.isArray(result) ? result : Array.isArray(result?.data) ? result.data : []);
  }, [response.data]);

  return (
    <section className="pr-10 max-lg:pr-6">
      <div className="flex items-center justify-between gap-3 px-3">
        <h1 className="text-xl font-MluvkaBold">{title}</h1>
        <div className="flex items-center gap-3">
          <input
            type="search"
            value={searchTitle}
            onChange={(event) => setSearchTitle(event.target.value)}
            placeholder="Search promo codes"
            aria-label="Search promo codes by title"
            className="w-56 rounded-full border border-[#D4DEF1] bg-white px-4 py-3 outline-none focus:border-primary"
          />
          <Link to={`${basePath}/create`} className="rounded-full bg-primary px-6 py-3 text-white">Create Promo Code</Link>
        </div>
      </div>
      <div className="mt-4 rounded-3xl bg-[#EFF4FD] p-6 max-lg:p-3">
        {response.isLoading ? <p className="p-4">Loading promo codes…</p> : items.length ? items.map((item) => (
          <PromoCodeRow key={item.id} item={item} basePath={basePath} onDeleted={(id) => setItems((current) => current.filter((promo) => promo.id !== id))} />
        )) : <p className="p-4 text-[#7D8CA7]">No partner promo codes found.</p>}
      </div>
      {response.data?.pagination?.total > 10 && <div className="mt-4"><Pagination current={page} pageSize={10} total={response.data.pagination.total} onChange={loadPage} /></div>}
    </section>
  );
};

export default UnifiedPromoCodes;
